import { useLocation } from 'react-router-dom';

export const usePageInUrlCheck = () => {
  const location = useLocation<string>();
  const params = new URLSearchParams(location.search);
  return params.get('page');
};
